// extracted by mini-css-extract-plugin
export default {"limitedLayout":"buMs0LPVbhOvWh8yLGcn","section":"q71PSEp0BHnujAD5kaxZ","attemptHeading":"mXg48Q9BfDMPBy_bDK5b"};